import { render, staticRenderFns } from "./dictType-configuration.vue?vue&type=template&id=bcef5bf4&scoped=true&"
import script from "./dictType-configuration.vue?vue&type=script&lang=js&"
export * from "./dictType-configuration.vue?vue&type=script&lang=js&"
import style0 from "./dictType-configuration.vue?vue&type=style&index=0&id=bcef5bf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcef5bf4",
  null
  
)

export default component.exports